import React from 'react';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

interface DotWithLabelProps {
  color?: string;
  className?: string;
  label: string;
}

const DotWithLabel: React.FC<DotWithLabelProps> = ({ color, label }) => {
  return (
    <div style={{ minWidth: '60px', display: 'flex', alignItems: 'center' }}>
      <div style={{ color }}>
        <FiberManualRecordIcon style={{ width: '10px', height: '10px', marginRight: '6px', marginTop: '3px' }} />
      </div>
      {label}
    </div>
  );
};

export default DotWithLabel;
